import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

export interface TooltipPosition {
  $top: number;
  $left: number;
}

export const TooltipChild = styled(Box).attrs(() => ({
  color: 'background',
  bg: 'primaryText',
  borderRadius: '5px',
  p: '10px',
}))<TooltipPosition>`
  position: fixed;
  top: ${p => p.$top}px;
  left: ${p => p.$left}px;
  transform: translateY(-50%);
  width: 197px;
  z-index: 1;
`;

export const InlineText = styled(Text)`
  display: inline;
`;

const linkStyles = css`
  text-decoration: none;
  padding: 0px 20px;
  position: relative;
  &:hover {
    background: ${p => p.theme.colors.heavyLineOutline};
  }
  &.active {
    background: ${p => p.theme.colors.primaryBaseC2};
  }
`;

export const StyledAnchor = styled.a`
  ${linkStyles}
`;

export const StyledNavLink = styled(NavLink)`
  ${linkStyles}
`;
